import React, { Component } from "react";
// import logo from './logo.svg';
import "./App.css";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";

import UnauthenticatedAppView from "./views/unauthenticated/UnauthenticatedAppView";
import LoginView from "./views/LoginView";
import LoadingView from "./views/LoadingView";
import AppView from "./views/AppView/.";
import LoginGate from "./components/login/LoginGate";
import LoadingGate from "./components/LoadingGate";

import { persistor, store } from "./store";

import { preloadApp, isPreloading, getPreloadError } from "./actions/preload";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

const LoggedInComponent = () => (
  <LoadingGate
    loadedComponent={AppView}
    loadAction={preloadApp}
    isLoading={isPreloading}
    getError={getPreloadError}
  />
);

const AuthenticatedAppView = () => (
  <LoginGate
    loggedInComponent={LoggedInComponent}
    loggedOutComponent={LoginView}
  />
);

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={<LoadingView />} persistor={persistor}>
          <Router>
            <Switch>
              <Route path="/_/" component={UnauthenticatedAppView} />
              <Route path="/" component={AuthenticatedAppView} />
            </Switch>
          </Router>
        </PersistGate>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./frontend/src/App.js